import request from "@utils/request";
import qs from "qs";

/**
 * 会员预约列表（按 authori-zation 头解析 accountId）
 * @param data { page, limit, status }
 *   status: 5全部/0待确认/1待到店/2已到店/3服务中/4已完成/-1已取消/-2爽约
 */
export function fetchPlan(data) {
  return request.post(`/wap/plan/list`, qs.stringify(data));
}

/**
 * 预约详情
 * @param planId
 */
export function get(planId) {
  return request.get(`/wap/plan/view/${planId}`);
}

/**
 * 保存预约（会员自助，进 0 待确认）
 * @param data { accountId, shopId, waiterId, planDate, startMin, endMin, items, notes, ... }
 */
export function save(data) {
  return request.post(`/wap/plan/save`, data);
}

/**
 * 取消预约（0/1 → -1）
 * @param id 预约id
 */
export function cancle(id) {
  return request.post(`/wap/plan/cancel/${id}`);
}

/**
 * 改约（1待到店 → 0待确认）
 * @param id 预约id
 * @param data { startMin, endMin, planDate, waiterId, ... }
 */
export function reschedule(id, data) {
  return request.post(`/wap/plan/reschedule/${id}`, data);
}

/**
 * 冲突检测（提交前预检）
 * @param data { techId, date, startMin, endMin, excludePlanId? }
 */
export function validate(data) {
  return request.post(`/wap/plan/validate`, data);
}

/**
 * 智能排位（返回可用候选时段，最早优先）
 * @param data { shopId, date, totalDuration, techId?, roomId? }
 */
export function recommend(data) {
  return request.post(`/wap/plan/recommend`, data);
}

/**
 * 门店营业时段配置（openMin/closeMin，无配置后端返回默认 540/1080）
 * @param shopId 门店id
 */
export function fetchBusinessHour(shopId) {
  return request.get(`/wap/plan/business-hour/${shopId}`);
}
